import React from "react";

function History() {
	return (
		<div style={{ marginBottom: '100px' }}>
			<div className="row banner" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'orange', backgroundSize: 'cover', backgroundPosition: 'center', height: '400px' }}>
				<img src="./images/maruthi.png" alt="image" style={{ width: '20%' }} />
			</div>
			<div class="container">
				<div class="row" >
					<div className="col-md-12 historybox" >
						<img src="./images/his-1.jpeg" alt="" style={{ width: '100%' }} />
						<h3 className="hheading"></h3>
						<p className="about">
							ചേര സാമ്രാജ്യകാലത്ത് വഞ്ചി എന്നാണ് ഇന്നത്തെ തിരുവഞ്ചിക്കുളം അറിയപ്പെട്ടിരുന്നത്. ചേര സാമ്രാജ്യത്തിനു നേരെ ​ചോളന്മാരുടെ ആക്രമണമുണ്ടായ കാലത്ത് ചേര രാജാവിനെ സഹായിച്ച ഈഴവന്മാരിൽ കാരയിൽ തറവാട്ടിലെ യോദ്ധാക്കൾക്ക് മുഖ്യ പങ്കുണ്ടായിരുന്നു. കാരയിൽ തറവാട്ടിലെ പുരോഹിതനായിരുന്ന കുഞ്ഞിവേലു ആചാര്യൻ‍ കുലദേവത പൂജകൾക്കു ശേഷം ഉപരി പഠനത്തിനായി കൊല്ലം ദേശത്തേക്ക് പോവുകയും താന്ത്രിക, മാന്ത്രിക വേദാന്ത പഠനങ്ങൾക്കായി യോഗിവര്യനായ കേശവൻ‍ എന്ന മഹായോഗിയുടെ ശിഷ്യത്വം സ്വീകരിക്കുകയും ചെയ്തു. <br />
							പഠനാനന്തരം തന്റെ പ്രത്യക്ഷ ഉപാസന മൂർത്തിയായ ​ശൈവ രൂപത്തിലുള്ള ഹനുമാൻ‍ സ്വാമിയെ പ്രിയ ശിഷ്യനായ കുഞ്ഞിവേലു ആചാര്യനു നൽകി അനുഗ്രഹിക്കുകയും ഗുരു സമാധി ആവുകയും ചെയ്തു. കുഞ്ഞിവേലു ആചാര്യൻ‍ ഹനുമാൻ‍ സ്വാമിയെ ത​ന്റെ ഗ്രാമത്തിലേക്ക് കൊണ്ട് വന്ന് പ്രതിഷ്ഠിക്കുകയും ചെയ്തു. രൗദ്രമൂർത്തിയായ സ്വാമിയുടെ രൗദ്രത കുറയ്ക്കുന്നതിനായി ബാലരൂപത്തിലുള്ള ശ്രീകൃഷ്ണ ഭഗവാനെ പ്രതിഷ്ഠിക്കുകയുണ്ടായി. ​തന്റെ ഗുരുവായ കേശവ ഗുരുവിനെ ഗുരുമുത്തപ്പനായും, കുലദേവതയായ തണ്ണികുളങ്ങര ഭഗവതിയെ​യും ഗണപതിയെയും ഉപദേവതകളായി പ്രതിഷ്ഠിച്ച ക്ഷേത്രം പിന്നീട് ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്രം എന്ന പേരിൽ പ്രസിദ്ധമായി

						</p>
					</div>
				</div>
				<div class="row" >
					<div className="col-md-4 imagebox" style={{ backgroundImage: 'url(./images/first.jpeg)', backgrooundPosition: 'center', backgroundSize: 'cover' }}>
					</div>
					<div className="col-md-8 historybox" >
						<h3 className="hheading">ഭാരതത്തിലാദ്യമായി ഹനുമാൻ സ്വാമിയുടെ കളമെഴുത്തു പാട്ടിൻ്റെ തുടക്കം </h3>
						<p className="about">
							ഹനുമാൻ സ്വാമിയുടെ രൂപക്കളമെഴുത്തു പാട്ടിന് മൂന്ന് തലമുറകൾക്ക് മുമ്പ് ഭാരതത്തിൽ ആദ്യമായി മാരുതിപുരം ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്രത്തിലാണ് തുടക്കം കുറിച്ചത്. ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്ര നടയിൽ ഹനുമാൻസ്വാമിക്ക് കളമെഴുത്ത് പാട്ട് രചിച്ചതും അവതരിപ്പിച്ചതും കോരുവേലൻ എന്ന മഹാനായ വ്യക്തിയാണ്. ഇന്നും ശ്രീകൃഷ്ണ മാരുതിപുരം ക്ഷേത്രത്തിലെ രോഹിണി മഹോത്സവത്തിലെ പ്രധാന ചടങ്ങ് ഹനുമാൻ സ്വാമിയുടെ രൂപക്കള മെഴുത്തും പാട്ടുമാണ്.
</p>
					</div>
				</div>
				


			</div>

		</div>
	);
}

export default History;
